<div class="social-icons flex">
  <a
    target="_blank"
    href="https://www.facebook.com/dialog/share?display=popup&app_id=150585651712541&href={{ url | finEncode }}"
    class="social-icon grey-200-bg circle no-underline flex flex--center ms-xxsmall-r"
  >
    <fcom-icon class="is-xxsmall flex--nogrow white-text" category="svg-library" name="facebook"></fcom-icon>
  </a>
  <a
    target="_blank"
    href="https://twitter.com/intent/tweet?url={{ url | finEncode }}"
    class="social-icon grey-200-bg circle no-underline flex flex--center"
  >
    <fcom-icon class="is-xxsmall flex--nogrow white-text" category="svg-library" name="twitter"></fcom-icon>
  </a>
</div>
